export class UserTransactionsFiltersRequest {
  transaction_type?: number;
}
